<div class="app-shell"><router-view></router-view><snackbar-container></snackbar-container><div class="impersonate-border" v-if="impersonateMode"></div></div>